import React from 'react';
import { Router, Route, Switch, withRouter } from 'react-router-dom';
import DataModel from '../../models/DataModel';
import MobileHeader from '../../components/MobileHeader';
import MobileSpinner from '../../components/MobileSpinner';
import ProjectDetailsHeader from '../../components/ProjectDetailsHeader';
import '../MobileWrapper.scss';
import './DelayCreateWrapper.scss';

export class DelayCreateWrapper extends React.Component {
  constructor(props) {
    super(props);
    const routerState = props.history.getState();
    this.state = {
      project: routerState ? routerState.project : null,
      iconSrc: null,
      delayType: null,
      delayText: null,
    };

    this.selectDelayType = this.selectDelayType.bind(this);
  }

  componentDidMount() {
    if (!this.state.project) {
      DataModel.projectsDAO.getProject(this.props.match.params.project_id)
        .then(project => this.setState({ project }));
    }
  }

  selectDelayType(delayType, typeText, iconSrc) {
    const { history } = this.props;
    const { project } = this.state;
    const delayText = typeText + ' Delay';
    this.setState({ delayType, delayText, iconSrc });

    history.push({
      pathname: '/mobile/projects/' + project.id + '/add-delay/report',
    });
  }
  
  render() {
    const { project, delayType, delayText, iconSrc } = this.state;

    if (!project) {
      return (
        <div className="mobile-wrapper">
          <MobileHeader headerTitle={'Delay Details'}/>
          <MobileSpinner/>  
        </div>  
      );
    }
    else return (
      <div className="mobile-wrapper">
        <MobileHeader headerTitle={'Delay Details'}/>
        <div className="content-wrapper delay-create-wrapper" id='create-wrapper'>
          <div className="delay-create-wrapper__heading">
            <ProjectDetailsHeader project={this.state.project} hideStatusBar={true}/>
            <h4>{'REPORT A DELAY'}</h4>
          </div>

          <div className="delay-create-wrapper__content">
            <Router history={this.props.history}>
              <Switch>
                {this.props.routes.map((route, i) => 
                  <Route 
                    path={route.path} 
                    key={route.component.name}
                    render={ routeProps => (
                      <route.component 
                        project={this.state.project} 
                        {...routeProps}
                        selectDelayType={this.selectDelayType}
                        iconSrc={iconSrc}
                        delayText={delayText}
                        delayType={delayType}
                      />
                    )} 
                  />
                )}
              </Switch>
            </Router>
          </div>
        </div>
      </div>
    );
  }
}

export default withRouter(DelayCreateWrapper);



// WEBPACK FOOTER //
// ./src/mobileWrappers/DelayCreateWrapper/index.js